<app-email-credit-note-modal [email]='this.customerEmail' [creditNote]='this.currentCreditNote'></app-email-credit-note-modal>
<div class="fullcontainer" >
  <br />
  <br />


  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>All Credit Notes</h2>
    </div>

    <br />
    <br />

<app-grid
entity='credit-note'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[relationships]='["invoice", "invoice.account"]'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
